module.exports = __webpack_public_path__ + "static/media/loading-process.bed32094.svg";